import {Component, OnInit, SimpleChanges, ViewChild} from '@angular/core';

import {EventRegistrationCode} from 'shared/classes/event-registration-code';
import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Company} from 'shared/models/target-groups/company';
import { TargetGroup, TARGETGROUP_DUMMIES } from 'shared/models/target-groups/target-group';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {EventRegistrationService} from './services/event-registration.service';

@Component({
  selector: 'event-registration/codes',
  templateUrl: './event-registration.component.html',
  styleUrls: ['./event-registration.component.css'],
})

export class EventRegistrationComponent implements OnInit {
  public allCodes: Array<EventRegistrationCode> = [];
  public filteredCodes: Array<EventRegistrationCode> = [];
  public fieldsToSearch: Array<Array<String>> = [];
  public companies: Array<Company> = [];
  public targetGroups: Array<TargetGroup> = [];
  public newCode: EventRegistrationCode = new EventRegistrationCode();
  public searchTerm: String;
  public currentPage: Event;
  public validState: String = 'all';
  public newCodeTargetGroup: TargetGroup = null;
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private eventRegistrationService: EventRegistrationService) { }

  public ngOnInit(): void {
    this.getAllCodes();

    this.eventRegistrationService.getAllCompanies()
      .subscribe((companies: Array<Company>) => {
        this.companies = companies;
        if (this.companies.length > 0) {
          this.newCode.company._id = this.companies[0]._id;
        }
      });
    this.eventRegistrationService.getAllTargetGroups()
    .subscribe((targetGroups: Array<TargetGroup>) => {
      this.targetGroups = targetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
    });
  }

  private showInvalidateModal(code: string): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie diesen Code ungültig machen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(code)
      .show();
  }

  public getAllCodes(): void {
    this.eventRegistrationService.getAllCodes()
      .subscribe((allCodes: Array<EventRegistrationCode>) => {
        this.allCodes = allCodes;
        this.filteredCodes = allCodes;
        this.prepareFieldsToSearch();
      });
  }

  public createCode(): void {
    console.log(this.newCodeTargetGroup);
    this.newCode.company = this.newCodeTargetGroup.companies[0];
    this.newCode.groups = this.newCodeTargetGroup.groups;
    this.newCode.categories = this.newCodeTargetGroup.categories;
    this.eventRegistrationService.createCode(this.newCode)
      .subscribe((createdCode: EventRegistrationCode) => {
        this.getAllCodes();
      });
  }

  public invalidateCode(code: string): void {
    this.eventRegistrationService.invalidateCode(code)
      .subscribe(() => {
        this.getAllCodes();
      });
  }

  public get filteredCodesByValidState(): Array<EventRegistrationCode> {
    return this.allCodes.filter((code: EventRegistrationCode) => {
      return this.filterByValidState(code);
    });
  }

  private filterByValidState(code: EventRegistrationCode): boolean {
    if (this.validState === 'all') {
      return true;
    }

    const showValid: boolean = this.validState === 'valid';
    return code.valid === showValid;
  }

  public filterCodes(codes: Array<EventRegistrationCode>): void {
    this.filteredCodes = codes;
  }

  public codeAlreadyExists(code: string) {
    return this.allCodes.some((codeListEntry: EventRegistrationCode) => {
      return codeListEntry.code === code;
    });
  }

  public getGroupCat(code: EventRegistrationCode): string {
    const sGroup = code.groups ? code.groups.map(group => group.name).join(", ") : "";
    const sCategories = code.categories ? code.categories.map(category => category.name).join(", ") : "";
    const sRes = sGroup+(sGroup != "" && sCategories != "" ? "; " : "")+sCategories;
    return sRes != "" ? "("+sRes+")" : "";
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredCodesByValidState.forEach((code: EventRegistrationCode) => {
      this.fieldsToSearch.push([
        code.code.toLowerCase(),
        code.company.name.toLowerCase(),
      ]);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/event-registration/event-registration.component.ts